import TierBadge, {TierBadgeProps} from './TierBadge';

export type {TierBadgeProps};
export default TierBadge;
